import { render, staticRenderFns } from "./versionList.vue?vue&type=template&id=93df86ba&scoped=true"
import script from "./versionList.vue?vue&type=script&lang=js"
export * from "./versionList.vue?vue&type=script&lang=js"
import style0 from "./versionList.vue?vue&type=style&index=0&id=93df86ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93df86ba",
  null
  
)

export default component.exports